import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { FlowDiagram } from '../components';

interface WelcomeStepProps {
  organizationName?: string;
}

export function WelcomeStep({ organizationName }: WelcomeStepProps) {
  const { t } = useTranslation('staff');

  return (
    <div className="p-6 space-y-6">
      {/* Welcome header */}
      <div className="text-center">
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center mx-auto mb-4">
          <Sparkles className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">
          {t('availability.wizard.welcome.title', "Let's get you ready for bookings!")}
        </h2>
        <p className="text-gray-500 mt-2 text-sm">
          {t(
            'availability.wizard.welcome.subtitle',
            "Here's how {{appName}} helps you manage your schedule",
            { appName: organizationName || 'Sloty' }
          )}
        </p>
      </div>

      {/* Flow diagram */}
      <div className="bg-gray-50 rounded-lg p-5 border border-gray-200">
        <FlowDiagram />
      </div>

      {/* Call to action */}
      <div className="text-center pt-2">
        <p className="text-sm text-gray-600">
          {t(
            'availability.wizard.welcome.cta',
            "Let's create your first service to get started"
          )}
        </p>
      </div>
    </div>
  );
}
